import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Founder/testing opt-out: open any page with ?internal=1 once and this browser
// stops sending analytics events (persisted in localStorage).
if (typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('internal')) {
  try {
    localStorage.setItem('vm_internal', '1');
  } catch {}
}

const isInternal = () => {
  try {
    return localStorage.getItem('vm_internal') === '1';
  } catch {
    return false;
  }
};

export const track = (event, meta = {}) => {
  if (isInternal()) return Promise.resolve();
  return axios
    .post(`${API}/analytics`, { event, path: window.location.pathname, meta })
    .catch(() => {});
};
